import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import config from "./config";
import ViewPayment from "./ViewPayment";
import "./App.css";
import io from "socket.io-client";
// import {initSocket} from "./socket";

const Payment = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [error, setError] = useState(null);
    const [email, setEmail] = useState("");
    const [currentTime, setCurrentTime] = useState(
        new Date().toLocaleTimeString("en-GB")
    );
    const [qrCode, setQrCode] = useState(null);
    const [paymentLink, setPaymentLink] = useState('');
    const location = useLocation();
    const [clock, setClock] = useState("");

    const [loading, setLoading] = useState(true); // Track API loading status
    const plate = searchParams.get("plate");
    const guid = searchParams.get("guid"); // Ensure 'guid' is retrieved
    const amount = searchParams.get("amount");
    const [paymentCompany, setPaymentCompany] = useState(null);
    const formRef = useRef(null);

    // const socketRef = useRef(null);
    //
    // useEffect(() => {
    //     // Create the socket only if it doesn't exist yet
    //     if (!socketRef.current) {
    //         socketRef.current = io("https://rtc.bluept.dev", {
    //             query: { deviceguid: guid },
    //         });
    //
    //     }
    //     socket.on("webpaySuccess", (data) => {
    //         console.log("Payment success received:", data);
    //         fetchCarInfo();
    //     });
    //
    // }, [searchParams]);

    useEffect(() => {
        // Auto-submit the form once the component has mounted and refs are available
        if (formRef.current) {
            formRef.current.submit();
        }
    }, []);


    // useEffect(() => {
    //     const fetchSites = async () => {
    //         try {
    //             const response = await fetch(`${config.app.serverUrl}/sites`);
    //             if (!response.ok) {
    //                 throw new Error("תקלה בטעינת האתרים");
    //             }
    //             const data = await response.json();
    //             const site = data.sites.find(
    //                 (site) => site.lane_guid === searchParams.get("guid")
    //             );
    //
    //             if (!site || !site.active) {
    //                 setError("עמדה לא פעילה. חזרה לעמוד הראשי...");
    //                 setTimeout(() => navigate("/", { replace: true }), 3000);
    //                 return;
    //             }
    //
    //             setLoading(false); // API resolved successfully
    //         } catch (error) {
    //             console.error("Error fetching sites:", error);
    //             setError("תקלה בטעינת האתרים. אנא נסו שנית.");
    //             setLoading(false);
    //         }
    //     };
    //
    //     fetchSites();
    // }, [navigate, searchParams]);

    useEffect(() => {
        // Create the socket connection once
        if(location.state?.paymentCompany === 'tranzila') {
            const socket = io(config.rtc.serverUrl, {
                query: { deviceguid: guid },
            });
            console.log("initSocket returned socket:", socket);

            socket.on("webpaySuccess", (data) => {
                console.log("Payment success received:", data);
                localStorage.setItem("webpaySuccessData", JSON.stringify(data));

                // fetchCarInfo();
            });
        }
    }, [guid]);


    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            setClock(now.toLocaleTimeString("en-GB")); // Update clock in 24-hour format
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {

        // Debug: Print location state and referrer
        // console.log("location", location);
        // console.log("location.state", location.state);
        // console.log("document.referrer", document.referrer);

        // Validate the navigation source
        const isFromViewPayment =
            location.state?.from === "/view-payment" ||
            document.referrer.includes("/view-payment");

        const isFromCompletion = location.state?.from === "/completion";
        if (!isFromViewPayment && !isFromCompletion) {
            setError("גישה לא תקינה לעמוד זה. חזרה לדף הראשי בעוד 3 שניות...");
            setTimeout(() => navigate(`/enter-car?guid=${searchParams.get("guid")}`, { replace: true }), 3000);
            return;
        }

        // Validate query parameters
        if (!guid || !plate || !amount) {
            setError("פרטים חסרים. חזרה לדף הראשי בעוד 3 שניות...");
            setTimeout(() => navigate(`/enter-car?guid=${searchParams.get("guid")}`, { replace: true }), 3000);
            return;
        }

        // Parse and set the amount from query parameters
        const parsedAmount = parseFloat(amount);
        if (isNaN(parsedAmount)) {
            setError("ערך סכום לא חוקי. חזרה לדף הראשי בעוד 3 שניות...");
            setTimeout(() => navigate(`/enter-car?guid=${searchParams.get("guid")}`, { replace: true }), 3000);
            return;
        }

    }, [navigate, searchParams, location.state]);

    useEffect(() => {
        // don’t inject it twice
        if (!document.querySelector('script[src="https://payments.payplus.co.il/statics/applePay/script.js"]')) {
            const s = document.createElement("script");
            s.src = "https://payments.payplus.co.il/statics/applePay/script.js";
            s.async = true;
            document.body.appendChild(s);
            // optional cleanup on unmount:
            return () => document.body.removeChild(s);
        }
    }, []);


    useEffect(() => {
        (async function getPaymentPage() {
           const res = await fetch(`${config.app.serverUrl}/get-vpof-payment-page/${searchParams.get("guid")}/${searchParams.get("plate")}/${amount}/${location?.state?.siteName}/${localStorage.getItem('userIdFromPal')}/${localStorage.getItem('placeId')}`);
            console.log(res);
           const resJson = await res.json();
           setQrCode(resJson.qr_code_image);
           setPaymentLink(resJson.payment_link);
        })();
        localStorage.removeItem('invoiceLink');
    }, []);

    // useEffect(() => {
    //     console.log(paymentLink);
    // }, [paymentLink]);

    // useEffect(() => {
    //     console.log(location.state?.paymentCompany);
    // } , [location.state?.paymentCompany]);

    return (
        <div className="container payment">
            {location.state?.from !== "/completion" && <button className="back-button" onClick={() => navigate(-1)}>
                <img
                    src={`${process.env.PUBLIC_URL}/arrow.png`}
                    alt="חץ אחורה"
                    className="arrow-icon"
                />
            </button>}
            {/*<img src="/logo.png" alt="Logo" className="logo"/>*/}
            {/*<h1 className="title">פרטי תשלום</h1>*/}
            {error ? (
                <div>
                    <span style={{
                        fontFamily: "Heebo",
                        fontStyle: "normal",
                        maxWidth: "80%", // limit width to prevent overflow
                        fontWeight: 400,
                        fontSize: 18,         // px
                        lineHeight: "27px",
                        textAlign: "center",
                        color: "red",}}>{error}</span>
                </div>
            ) : (
                location.state?.paymentCompany === 'payplus' ? (<div className="input-section payment">
                        <iframe allowpaymentrequest="allowpaymentrequest" id="pp_iframe" scrolling="no"
                                style={{border: "none"}} className="responsive-iframe" src={paymentLink}
                                title="Payment Page"/>
                        {/*<iframe src={qrCode} title="QR Code" />*/}
                    </div>) :
                    (
                        <div>

                            <form
                                ref={formRef}
                                action="https://direct.tranzila.com/bluepark/iframenew.php?lang=il"
                                target="tranzila"
                                method="POST"
                                noValidate
                                autoComplete="off"
                                // lng="il"
                            >
                                {/* Pass the amount in a hidden field, so user doesn't enter it */}
                                <input type="hidden" name="sum" value={amount}/>
                                {/*<input type="email" name="email" value={"g@fg.com"}*/}
                                {/*       onChange={(e) => setEmail(e.target.value)}/>*/}
                                {/* Additional hidden fields as per your need */}
                                <input type="hidden" name="buttonLabel" value="Pay"/>
                                <input type="hidden" name="success_url_address"
                                       value={`https://vpof.bluept.dev/completion?guid=${guid}&plate=${plate}&amount=${amount}&guid=${guid}`}/>
                                <input type="hidden" name="fail_url_address" value="https://vpof.bluept.dev/error"/>
                                <input type="hidden" name="notify_url_address" value="https://rtc.bluept.dev/getTransactioin"/>
                                <input type="hidden" name="currency" value="1"/>
                            </form>


                            {/*
        The named iframe that shows the Tranzila response (the form's target)
      */}
                            <iframe
                id="tranzila-frame"
                name="tranzila"
                allowPaymentRequest="true"
                style={{width: "100%", height: "800px", border: "none"}}
             title="Tranzila Payment"
        />
                        </div>

        // <main className="min-h750">
        //     <div className="container">
        //         <section id="main-content">
        //             <div className="row text-center mt-5">
        //                 <div className="col">
        //                     <h1 className="display-3 text-primary">Pay Amount</h1>
        //                 </div>
        //             </div>
        //             <div className="row mt-5">
        //                 <div className="col-md-6">
        //                     <p className="text-center">Choose Amount:</p>
        //                     <form action="https://direct.tranzila.com/jira/iframenew.php" target="tranzila" method="POST" novalidate="novalidate" autocomplete="off">
        //                         <div className="form-group">
        //                             <label for="amount">Amount:</label> <br/>
        //                             <input name="sum" value="5" type="number" id="sum" className="form-control" />
        //                             <span className="text-danger"></span>
        //                         </div>
        //                         <input type="hidden" name="buttonLabel" value="Pay" />
        //
        //                         <input type="hidden" name="success_url_address" value="https://yoursite.com/success_url_address" />
        //                         <input type="hidden" name="fail_url_address" value="https://yoursite.com/fail_url_address" />
        //                         <input type="hidden" name="currency" value="1" />
        //
        //                         <button type="submit" name="submit" className="btn btn-primary mt-3" value="pay">pay</button>
        //                     </form>
        //                 </div>
        //             </div>
        //             <div class="row mt-5">
        //                 <div class="col-md-6">
        //                     <div class="" style={{width: "800px", height: "800px"}}>
        //                         <iframe id="tranzila-frame" allowpaymentrequest='true' name="tranzila" src="" style={{width: "100%", height: "100%"}}></iframe>
        //                     </div>
        //                 </div>
        //             </div>
        //         </section>
        //     </div>
        // </main>
    )
)}
    {/*<footer className="footer footer-payment">*/}
    {/*    <div className="footer-content">*/}
    {/*        <p>*/}
    {/*            מספר רכב נוכחי: <span className="highlight">{plate || "לא הוזן"}</span>*/}
    {/*        </p>*/}
    {/*        <p>*/}
    {/*            שעה נוכחית:{" "}*/}
    {/*            <span className="highlight">{clock}</span>*/}
    {/*        </p>*/}
    {/*        <p>&copy; {new Date().getFullYear()} BluePT</p>*/}
    {/*    </div>*/}
    {/*</footer>*/}
</div>
)
}

export default Payment;
